import React, { useCallback } from "react";
import { Box, Button, Grid, TextField, Typography, Divider } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ApprenticeTable = ({ rows, setRows, additionalValue, setAdditionalValue, isEditModeOn }) => {
    const handleAddRow = useCallback(() => {
        setRows(prev => [
        ...prev,
        { label: `Apprentice ${prev.length + 1}`, value: "" }
        ]);
    }, [setRows]);

  const handleDeleteRow = useCallback(() => {
    setRows(prev => {
      if (prev.length <= 1) return prev;
      return prev.slice(0, -1);
    });
  }, [setRows]);

  const handleRowChange = useCallback((index, value) => {
    if (!/^\d{0,3}$/.test(value)) return;
    setRows(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], value };
      return updated;
    });
  }, [setRows]);

  const handleAdditionalChange = useCallback((value) => {
    if (/^\d{0,3}$/.test(value)) {
      setAdditionalValue(value);
    }
  }, [setAdditionalValue]);

  // const renderRow = (label, value, onChange, isStatic = false) => (
  //   <Box key={label} display="flex" alignItems="center" sx={{minHeight: 44, border: "1px solid #ccc", borderTopLeftRadius: label === "Apprentice 1" ? 4 : 0, borderTopRightRadius: label === "Apprentice 1" ? 4 : 0, borderBottomLeftRadius: isStatic ? 4 : 0, borderBottomRightRadius: isStatic ? 4 : 0}}>
  //     <Box width="25%" bgcolor="#f3f3f3" px={2} py={1.3} display="flex" alignItems="center" borderRight="1px solid #ccc" fontSize="14px">{label}</Box>

  //     <Box flex={1} px={2}>
  //       <TextField fullWidth size="small" placeholder="Please Enter" variant="standard" value={value} onChange={e => onChange(e.target.value)} InputProps={{disableUnderline: true, sx: { backgroundColor: "white", fontSize: "14px" }}}/>
  //     </Box>
  //   </Box>
  // );

  const renderRow = (label, value, onChange, isStatic = false) => (
  <Box key={label} display="flex" alignItems="center" sx={{minHeight: 44, border: "1px solid #ccc", borderTopLeftRadius: label === "Apprentice 1" ? 4 : 0, borderTopRightRadius: label === "Apprentice 1" ? 4 : 0, borderBottomLeftRadius: isStatic ? 4 : 0,borderBottomRightRadius: isStatic ? 4 : 0}}>
    <Box width="25%" bgcolor="#f3f3f3" px={2} py={1.3} display="flex" alignItems="center" borderRight="1px solid #ccc" fontSize="14px">
      {label === "Each additional apprentice" ? (
        <Box display="flex" alignItems="center" gap={0.5}>
          <span>{label}</span>
          <Tooltip title="Journey Workers needed for each apprentice beyond the ones specified above." placement="top" arrow>
            <InfoOutlinedIcon fontSize="small" sx={{ color: "text.secondary", cursor: "pointer" }} />
          </Tooltip>
        </Box>
      ) : (
        label
      )}
    </Box>

    <Box flex={1} px={2}>
      <TextField fullWidth size="small" placeholder="Please Enter" variant="standard" value={value} onChange={e => onChange(e.target.value)} InputProps={{disableUnderline: true, sx: { backgroundColor: "white", fontSize: "14px" }}}/>
    </Box>
  </Box>
);


  return (
    <Box width="100%" mt={4}>
      <Grid container justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle2" fontWeight={600}>Additional Journey Worker Required</Typography>
        {isEditModeOn && (
        <Box display="flex" gap={2}>
          <Button variant="outlined" size="small" onClick={handleDeleteRow} disabled={rows.length <= 2}>Delete Row</Button>
          <Button variant="contained" size="small" onClick={handleAddRow}>Add Row</Button>
        </Box>
        )}
      </Grid>

      <Divider sx={{ mb: 2 }} />

      {rows.map((row, idx) => renderRow(row.label, row.value, val => handleRowChange(idx, val)))}

      {renderRow("Each additional apprentice", additionalValue, handleAdditionalChange, true)}
    </Box>
  );
};

export default ApprenticeTable;